export default __webpack_public_path__ + "static/media/mini-14.1b386060.jpg";